<template>
  <v-container>
    <!-- TODO DRY also used in App.vue -->
    <div v-if="actionLoading" class="text-center mt-12">
      <p class="loading-message">
        Andmete laadimine
      </p>
      <v-progress-circular
        :size="70"
        :width="6"
        color="primary"
        indeterminate
      />
    </div>
    <div v-else-if="action404" class="text-center mt-12">
      Sellise IDga tegevust ei ole olemas<br />
      või pole sul õigust seda näha.
    </div>
    <div v-else-if="actionError" class="text-center mt-12 grand-error">
      <b>Viga andmete laadimisel</b><br />
      Rakendust ei saa käivitada,<br />
      kuna andmete laadimisel ilmnes tõrge.
    </div>
    <v-row dense class="title">
      <v-col>
        <h2 v-if="actionId">
          Muuda tegevust
        </h2>
        <h2 v-else>
          Lisa uus tegevus
        </h2>
      </v-col>
    </v-row>
    <div class="add-action-wrapper">
      <div class="form-container">
        <v-form
          v-show="!(actionLoading || action404 || actionError)"
          ref="form"
        >
          <div class="form-group-divider">
            Inimesed
          </div>
          <v-row dense>
            <v-col cols="9">
              <search-and-pick
                ref="clientPicker"
                v-model="selectedClients"
                :items="clientPickerItems"
                label="Vali kliendid"
              />
            </v-col>
            <v-col cols="3">
              <v-switch
                v-model="showOnlyMyClients"
                label="Ainult minu kliendid"
              />
            </v-col>
          </v-row>
          <search-and-pick
            ref="employeePicker"
            v-model="$v.employees.$model"
            :errors="employeesErrors"
            :items="employeePickerItems"
            label="Vali töötajad"
          />
          <div class="form-group-divider">
            Aeg
          </div>
          <v-row dense>
            <v-col cols="6">
              <date-picker v-model="startDate" label="Vali alguskuupäev" />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="startTime"
                v-mask="'##:##'"
                :error-messages="startTimeErrors"
                label="Vali alguse kellaaeg"
                return-masked-value
                @blur="$v.startTime.$touch()"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6">
              <date-picker
                v-model="endDate"
                :error-messages="endDateErrors"
                clearable
                label="Vali lõppkuupäev"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="$v.endTime.$model"
                v-mask="'##:##'"
                :error-messages="endTimeErrors"
                clearable
                label="Vali lõpu kellaaeg"
                return-masked-value
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <div style="width: 200px">
                <v-checkbox
                  label="on toimunud"
                  v-model="isDone"
                  :disabled="isDoneDisabled"
                  style="float: left"
                />
                <Explanation style="overflow: hidden;">
                  Kui tegevuse alguse aeg on on tulevikus, luuakse tegevus
                  olekus "planeeritud".<br />
                  Neid näidatakse kalendris heledama värviga ega kajastata
                  aruannetes.<br />
                  Kui aeg on jõudnud nii kaugele, et tegevus on toimunud,<br />
                  saab selle tehtuks märkida märgistades selle linnukese.<br />
                </Explanation>
              </div>
            </v-col>
          </v-row>
          <div class="form-group-divider">
            Sündmus
          </div>
          <v-select
            v-model="service"
            :items="services.filter(s => s.is_archived == false)"
            clearable
            item-text="name"
            item-value="id"
            label="Vali teenus"
          />
          <v-text-field v-model="location" label="Asukoht" />
          <v-slider
            v-model="priority"
            :color="priorityColorMap[String(priority)]"
            :max="40"
            :min="10"
            :tick-labels="['madal', 'keskmine', 'kõrge', 'kriitiline']"
            always-dirty
            label="Tähtsus"
            step="10"
          />
          <v-textarea
            v-model="$v.description.$model"
            :error-messages="descriptionErrors"
            label="Sündmuse kirjeldus"
          />
          <v-btn
            v-if="actionId"
            :loading="deletePending"
            color="red"
            @click="processDelete"
          >
            Kustuta
          </v-btn>
          <v-btn
            :loading="savePending"
            color="primary"
            @click="processSave(false)"
          >
            Salvesta
          </v-btn>
        </v-form>
      </div>

      <div v-if="!actionId">
        <div class="form-group-divider">Kiirvalikud</div>
        <v-row v-if="actionTemplateLoading" dense>
          <v-col cols="12">
            <p>Andmete laadimine...</p>
          </v-col>
        </v-row>
        <v-row v-else-if="actionTemplateError" dense>
          <v-col cols="12">
            <p style="color:red">
              Andmete laadimisel ilmnes viga
            </p>
          </v-col>
        </v-row>
        <v-row v-else dense class="templates">
          <div v-for="template in actionTemplates" :key="template.id">
            <v-btn
              class="template-btn"
              color="secondary"
              @click="fillFormFromTemplate(template)"
            >
              {{ getActionTemplateBtnText(template) | truncate(35) }}
            </v-btn>
          </div>
        </v-row>
      </div>
    </div>

    <ConfirmationDialog
      v-model="showConfirmationDialog"
      :message="confirmationMessage"
      @forceSave="processSave(true)"
    />

    <v-snackbar v-model="snackbar" :timeout="3000">
      {{ notification }}
      <v-btn text color="pink" @click.native="snackbar = false">
        Sulge
      </v-btn>
    </v-snackbar>
  </v-container>


</template>

<script>
import { helpers, required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'

import API from '@/dataAccess/api'
import SearchAndPick from '@/components/SearchAndPick.vue'
import DatePicker from '@/components/DatePicker.vue'
import Explanation from '@/components/Explanation'

import { getCurrentISODateString, timeRegex } from '@/utils/datetime'
import {getApiRequestErrorMsg} from '@/dataAccess/api'
import Employee from '@/dataAccess/models/Employee'
import Service from '@/dataAccess/models/Service'
import LimitedClient from '@/dataAccess/models/LimitedClient'
import AccessibleClient from '@/dataAccess/models/AccessibleClient'
import ConfirmationDialog from '@/views/ActionForm/ConfirmationDialog'

export default {
  components: {
    Explanation,
    ConfirmationDialog,
    SearchAndPick,
    DatePicker
  },
  directives: { mask },
  props: {
    /**
     * Present, if the form is used to modify an existing action,
     * not given if the form is used to add a new action.
     */
    actionId: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      // form fields
      selectedClients:
        typeof this.$route.query.client !== 'undefined'
          ? [].concat([].concat(this.$route.query.client).map(it => Number(it)))
          : [],
      showOnlyMyClients: true,
      employees: [this.$store.getters.user.id],
      startDate: getCurrentISODateString(),
      endDate: getCurrentISODateString(),
      service: null,
      description: '',
      startTime: getCurrentTime(),
      originalStartTime: getCurrentTime(),
      endTime: '',
      isDone: true,
      location: '',
      priority: 20, // medium priority
      // other
      services: Service.all().sort(Service.compare),
      actionTemplateLoading: true,
      actionTemplateError: false,
      actionTemplates: [],
      showConfirmationDialog: false,
      //
      actionLoading: false,
      actionError: false,
      action404: false,
      //
      savePending: false,
      deletePending: false,
      //
      priorityColorMap: {
        '10': this.$vuetify.theme.themes.light.priority.low,
        '20': this.$vuetify.theme.themes.light.priority.normal,
        '30': this.$vuetify.theme.themes.light.priority.high,
        '40': this.$vuetify.theme.themes.light.priority.critical
      },
      notification: '',
      snackbar: false
    }
  },
  computed: {
    clientPickerItems() {
      const clients = this.showOnlyMyClients
        ? AccessibleClient.notArchivedAndAccessibleToUser()
        : LimitedClient.getNotArchived()
      return clients.map(obj => {
        return { name: obj.fullName, avatar: obj.avatar, id: obj.id }
      })
    },
    employeePickerItems() {
      const employees = Employee.getNotArchived()
      return employees.map(obj => {
        return { name: obj.username, avatar: obj.avatar, id: obj.id }
      })
    },
    currentEmployeeForPicker() {
      return this.employeePickerItems.filter(
        obj => obj.name === this.$store.getters.user.username
      )
    },
    isDoneDisabled() {
      return isFuture(this.startDate, this.startTime)
    },
    formattedAction() {
      return {
        employees: this.employees,
        clients: this.selectedClients,
        start: getDateTimeString(this.startDate, this.startTime),
        end: getDateTimeString(this.endDate, this.endTime),
        is_done: this.isDone,
        description: this.description,
        service: this.service,
        location: this.location,
        priority: this.priority
      }
    },
    /**
     * @returns {String} A confirmation message if needed, an empty string otherwise
     * Firstly, it there are some empty fields, indicate that.
     * Secondly, if the description contains word `TÄIENDA`, indicate that
     */
    confirmationMessage() {
      const e = this.confirmationMessage_EmptyFields
      const t = this.confirmationMessage_Description
      if (e) return e
      if (t) return t
      return ''
    },
    confirmationMessage_EmptyFields() {
      const emptyFields = []
      if (!this.selectedClients.length) emptyFields.push('"kliendid"')
      if (!this.endDate) emptyFields.push('"lõppkuupäev"')
      if (!this.service) emptyFields.push('"teenus"')

      if (!emptyFields.length) return ''
      const f = emptyFields.length === 1 ? 'väli' : 'väljad'
      const n = emptyFields.length === 1 ? 'seda' : 'neid'
      return `Sul on jäänud valimata ${f} <b>${emptyFields.join(
        ', '
      )}</b>.<br>Kas oled kindel, et ei soovi ${n} lisada?`
    },
    confirmationMessage_Description() {
      if (this.description.indexOf('TÄIENDA') !== -1) {
        return 'Tegevuse kirjeldus sisaldab sõna <b>`TÄIENDA`</b>.<br>Kas sa oled kindel, et ei soovi seda asendada?'
      } else {
        return ''
      }
    },
    // Errors
    descriptionErrors() {
      const errors = []
      if (!this.$v.description.$dirty) return errors
      !this.$v.description.required && errors.push('See väli on kohustuslik')
      return errors
    },
    employeesErrors() {
      const errors = []
      if (!this.$v.employees.$dirty) return errors
      !this.$v.employees.required && errors.push('See väli on kohustuslik')
      return errors
    },
    endDateErrors() {
      const errors = []
      if (!this.$v.endDate.$dirty) return errors
      !this.$v.endDate.assertEndDateToBeLater &&
        errors.push('Lõppkuupäev peab olema hilisem kui alguskuupäev.')
      !this.$v.endDate.assertEndDateAndTimeToBeBothGivenOrMissing &&
        errors.push(
          'Kui tegevuse lõpu kellaaeg on antud, tuleb valida ka lõpu kuupäev.'
        )
      return errors
    },
    endTimeErrors() {
      const errors = []
      if (!this.$v.endTime.$dirty) return errors
      !this.$v.endTime.validateTimeOptional &&
        errors.push('Sisesta kellaaeg korrektses formaadis.')
      !this.$v.endTime.assertEndTimeToBeLater &&
        errors.push(
          'Tegevuse lõpu kellaaeg peab olema hilisem kui alguse kellaaeg.'
        )
      !this.$v.endTime.assertEndDateAndTimeToBeBothGivenOrMissing &&
        errors.push(
          'Kui tegevuse lõpu kuupäev on antud, tuleb valida ka lõpu kellaaeg.'
        )
      return errors
    },
    startTimeErrors() {
      const errors = []
      if (!this.$v.startTime.$dirty) return errors
      !this.$v.startTime.validateTime &&
        errors.push('Sisesta kellaaeg korrektses formaadis.')
      return errors
    }
  },
  watch: {
    /**
     * This is necessary because when `showOnlyMyClients` is switched from `false` to `true`
     * and thus some clients are no longer included in the selection options,
     * they should not be selected even if they were already selected before the switching.
     */
    showOnlyMyClients() {
      const accessibleClientsIDs = AccessibleClient.notArchivedAndAccessibleToUser().map(
        obj => obj.id
      )
      this.$refs.clientPicker.setValue(
        this.selectedClients.filter(obj =>
          accessibleClientsIDs.includes(obj.id)
        )
      )
    },
    startDate() {
      this.setFutureActionToPlannedState()
    },
    startTime() {
      this.setFutureActionToPlannedState()
    }
  },
  created() {
    // TODO check route name here
    if (this.actionId) {
      this.fillFormFromAction()
    } else {
      this.fetchActionTemplates()
    }
  },
  methods: {
    setFutureActionToPlannedState() {
      if (isFuture(this.startDate, this.startTime)) {
        this.isDone = false
      }
    },
    /**
     * @param {Boolean} forceSave There are fields in the form, which are optional, but should still usually be filled.
     * By default a conformation box is shown when some of the fields are empty.
     * When `forceSave=true`, no confirmation box is shown.
     */
    async processSave(forceSave) {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      if (this.confirmationMessage && !forceSave) {
        this.showConfirmationDialog = true

        return
      }
      this.savePending = true
      try {
        let message
        if (this.actionId) {
          await API.updateAction(this.actionId, this.formattedAction)
          message = 'Tegevus on uuendatud'
        } else {
          await API.addAction(this.formattedAction)
          message = 'Tegevus on salvestatud'
        }
        this.savePending = false
        this.$eventBus.$emit('notification', message)
        this.redirectOnSuccess()
      } catch (error) {
        this.savePending = false
        this.$eventBus.$emit(
          'notification',
          getApiRequestErrorMsg(error.response, 'Tegevuse salvestamine nurjus')
        )
      }
    },
    async processDelete() {
      // Can only be called when changing an existing action, so `this.actionId` must be present
      this.deletePending = true
      try {
        await API.deleteAction(this.actionId)
        this.deletePending = false
        this.$eventBus.$emit('notification', 'Tegevus on kustutatud')
      } catch (e) {
        this.deletePending = false
        console.log(e)
        this.$eventBus.$emit('notification', 'Tegevuse kustutamine nurjus')
      }
    },
    async fetchActionTemplates() {
      try {
        const response = await API.getActionTemplates()
        this.actionTemplates = response.data
      } catch (e) {
        this.actionTemplateError = true
      } finally {
        this.actionTemplateLoading = false
      }
    },
    getActionTemplateBtnText(template) {
      if (template.service) {
        return `${Service.find(template.service).abbreviation}: ${
          template.description
        }`
      } else {
        return template.description
      }
    },
    fillFormFromTemplate(template) {
      if (!this.description) {
        this.description = template.description
      }
      // `startTime` is automatically changed only if it has the automatically set value (current time).
      // If the user has already picked another time, it will not be overridden
      if (this.startTime === this.originalStartTime) {
        this.startTime = template.start_time.slice(0, 5)
      }
      if (!this.location) {
        this.location = template.location
      }
      if (template.end_time && !this.endTime) {
        this.endTime = template.end_time.slice(0, 5)
      }
      if (template.service && !this.service) {
        this.service = template.service
      }
      if (!this.selectedClients.length) {
        this.$refs.clientPicker.setValue(template.clients)
      }
    },
    /**
     * If updating an existing action, fill the form from that action
     */
    async fillFormFromAction() {
      let action
      try {
        this.actionLoading = true
        const response = await API.getAction(this.actionId)
        action = response.data
      } catch (e) {
        if (e.response.status === 404) {
          this.action404 = true
        } else {
          this.actionError = true
        }
      } finally {
        this.actionLoading = false
      }

      this.$refs.clientPicker.setValue(action.clients)
      this.$refs.employeePicker.setValue(action.employees)

      this.startDate = getDateFromString(action.start)
      this.startTime = getTimeFromString(action.start)
      this.isDone = action.is_done
      if (action.end) {
        this.endDate = getDateFromString(action.end)
        this.endTime = getTimeFromString(action.end)
      } else {
        this.endDate = null
        this.endTime = null
      }

      this.description = action.description
      this.service = action.service
      this.location = action.location
      this.priority = action.priority
    },
    /**
     * After successfully saving the Action,
     * redirect the user to the calendar view
     * of one of the clients associated with that action.
     * If no clients are associated with that action, redirect to homepage.
     */
    redirectOnSuccess() {
      if (this.selectedClients.length > 0) {
        this.$router.push({
          name: 'ClientView',
          params: { Id: this.selectedClients[0] }
        })
      } else {
        this.$router.push({ name: 'Dashboard' })
      }
    }
  },
  validations: {
    description: {
      required
    },
    employees: {
      required
    },
    endDate: {
      assertEndDateToBeLater,
      assertEndDateAndTimeToBeBothGivenOrMissing
    },
    endTime: {
      validateTimeOptional,
      assertEndTimeToBeLater,
      assertEndDateAndTimeToBeBothGivenOrMissing
    },
    startTime: {
      validateTime
    }
  }
}

const DATE_TIME_STR_REGEX = /([0-9]{4}-[0-9]{2}-[0-9]{2})T([0-9]{2}):([0-9]{2}).*/

function getDateTimeString(date, timeString) {
  if (date && timeString) {
    const timeMatches = timeRegex.exec(timeString)
    return `${date}T${timeMatches[0]}:${timeMatches[1]}`
  }
  return null
}

function getDateFromString(str) {
  const matches = DATE_TIME_STR_REGEX.exec(str)
  return matches[1]
}

function getTimeFromString(str) {
  const matches = DATE_TIME_STR_REGEX.exec(str)
  return `${matches[2]}:${matches[3]}`
}

function isFuture(date, time) {
  return new Date(getDateTimeString(date, time)) > new Date()
}

function getCurrentTime() {
  const date = new Date()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${hours}:${minutes}`
}

function validateTime(timeString) {
  return timeRegex.test(timeString)
}

function validateTimeOptional(timeString) {
  return !helpers.req(timeString) || validateTime(timeString)
}

function assertEndDateToBeLater(endDateString, vm) {
  if (!endDateString) return true
  const startDate = new Date(vm.startDate)
  const endDate = new Date(endDateString)
  const timeDiff = endDate - startDate
  return timeDiff >= 0
}

function assertEndTimeToBeLater(endTime, vm) {
  if (vm.startDate === vm.endDate && endTime) {
    return (
      Number(vm.startTime.replace(':', '')) < Number(endTime.replace(':', ''))
    )
  }
  return true
}

function assertEndDateAndTimeToBeBothGivenOrMissing(value, vm) {
  if (value) return true
  const endTime = vm.endTime
  const endDate = vm.endDate
  return (endDate && endTime) || (!endDate && !endTime)
}
</script>

<style scoped>
#show-only-my-clients-switch label {
  font-size: small;
  padding-left: 5px;
}

.form-group-divider {
  font-size: 22px;
  opacity: 0.8;
  margin-top: 15px;
  margin-bottom: -5px;
}

.form-container {
  flex: 1;
  max-width: 700px;
  padding-right: 30px;
}

.title {
  margin-bottom: -15px;
}

.templates {
  flex-direction: column;
}

.template-btn {
  margin: 10px 0;
  width: 100%;
}

.add-action-wrapper {
  display: flex;
  justify-content: space-between;
}

@media (max-width: 900px) {
  .add-action-wrapper {
    flex-direction: column;
  }
}
</style>
